// extracted by mini-css-extract-plugin
export default {"block":"App_block__D10jH","auth":"App_auth__QE-98","default":"App_default__uFpc1","main":"App_main__-kK8X"};